import { UserStatus } from 'src/@types/user-status';
import { type IWorkspaceUser, UserType } from 'src/@types/workspace-info';
import type { AuthUserType } from 'src/auth/types';

type UserProps = Partial<IWorkspaceUser | AuthUserType>;

export function getEffectiveUserStatus(user: UserProps): UserStatus {
  if (user?.type === UserType.INTEGRATION) {
    return UserStatus.ONLINE;
  }

  if (!user || !user.status) {
    return UserStatus.OFFLINE;
  }

  if (user.status === UserStatus.ONLINE) {
    return user.customStatus?.status ?? UserStatus.ONLINE;
  }

  return user.status;
}
